import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export type OrdemServico = {
  ordemServicoId: string;
  idExterno: string;
  numero: number;
  dataAbertura: string;
  situacao: string;
  operacaoId: string;
  operacaoIdExterno: string;
  equipeId: string;
  equipeIdExterno: string;
  centroCustoId: string;
  centroCustoIdExterno: string;
  dataPrevisaoInicio: string;
  dataPrevisaoEncerramento: string;
  observacao?: string;
  talhoes: OrdemServicoTalhao[];
  componentes: OrdemServicoComponente[];
  vazao?: number;
  capacidadeTanque?: number;
};

export type OrdemServicoTalhao = {
  ordemServicoTalhaoId: string;
  idExterno: string;
  talhaoId: string;
  talhaoIdExterno: string;
  area: number;
};

export type OrdemServicoComponente = {
  ordemServicoComponenteId: string;
  idExterno: string;
  componenteId: string;
  componenteIdExterno: string;
  quantidade: number;
  quantidadeProducao: number;
  quantidadeUtilizacao: number;
  alvos: OrdemServicoComponenteAlvo[];
};

export type OrdemServicoComponenteAlvo = Record<string, never>;

export function useGetOrdemServico(
  ordemServicoId: string,
) {
  return useQuery(
    [URL.ORDEM_SERVICO.OBTER_POR_ID(ordemServicoId)],
    async () => {
      const { data } = await http.get<OrdemServico>(URL.ORDEM_SERVICO.OBTER_POR_ID(ordemServicoId));
      return data;
    },
    {
      enabled: !!ordemServicoId,
    }
  );
}
